import { call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { _setResponseListForm, reDirectPage, setRequestForm } from '../../../lib/common';
import toastMsg from '../../../lib/toastMsg';
import versionToastMsg from '../../../constants/service/toastMsg/versionToastMsg';
import versionActions from './actions';
import VersionApi from '../../../lib/api/version/VersionApi';
import { VERSION_LIST_URL_PATH } from '../../../constants/service/common/urlConstants';

function* fetchList() {
  /**
   *  [버전 전체 리스트] 버전 전체 리스트 요청하기
   */
  yield takeEvery(versionActions.GET_VERSION_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(VersionApi.getVersionList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(versionToastMsg.GET_VERSION_LIST_REQUEST_SUCCESS);

        const data = {
          versionList: _setResponseListForm(result.data.versionList, result.data.totalCnt, payload),
        };
        /**
         *  백단에서 받아온 데이터를 reducer로 보낸다.
         */
        yield put({ type: versionActions.GET_VERSION_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(versionToastMsg.GET_VERSION_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   * [버전 등록] 버전 등록 요청하기
   */
  yield takeEvery(versionActions.INSERT_VERSION_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(VersionApi.insertVersion, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(versionToastMsg.INSERT_VERSION_REQUEST_SUCCESS);

        /**
         *  성공하면 버전 전체 리스트 페이지로 이동한다.
         */
        reDirectPage({ path: VERSION_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(versionToastMsg.INSERT_VERSION_REQUEST_ERROR, error);
    }
  });

  /**
   * [버전 편집] 버전 편집 요청하기
   */
  yield takeEvery(versionActions.EDIT_VERSION_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(VersionApi.editVersion, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(versionToastMsg.EDIT_VERSION_REQUEST_SUCCESS);

        /**
         *  검색 조건
         */
        const state = yield select((state) => {
          return {
            searchData: state.version.versionList.searchData,
            searchOption: state.version.versionList.searchOption,
            pagination: state.version.versionList.pagination,
          };
        });

        /**
         *  성공하면 버전 전체 리스트 페이지로 이동한다.(검색 조건으로)
         */
        reDirectPage({ path: VERSION_LIST_URL_PATH }, state);
      }
    } catch (error) {
      toastMsg.error(versionToastMsg.EDIT_VERSION_REQUEST_ERROR, error);
    }
  });

  /**
   *  [버전 삭제] 버전 삭제 요청하기
   */
  yield takeEvery(versionActions.DELETE_VERSION_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(VersionApi.deleteVersion, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(versionToastMsg.DELETE_VERSION_REQUEST_SUCCESS);

        /**
         *  성공하면 버전 전체 리스트 페이지로 이동한다.
         */
        reDirectPage({ path: VERSION_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(versionToastMsg.DELETE_VERSION_REQUEST_ERROR, error);
    }
  });

  /**
   * [버전 상세] 버전 상세 요청하기
   */
  yield takeEvery(versionActions.GET_VERSION_INFO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(VersionApi.getVersionDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(versionToastMsg.GET_VERSION_INFO_REQUEST_SUCCESS);
        yield put({ type: versionActions.GET_VERSION_INFO_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(versionToastMsg.GET_VERSION_INFO_REQUEST_ERROR, error);
    }
  });
}

export default function* versionSaga() {
  yield fork(fetchList);
}
